import Chart from "chart.js/auto"

const LIGHT = {
  text: "#64748b",
  grid: "#e2e8f0",
  background: "transparent"
}

const DARK = {
  text: "#a1a1aa",
  grid: "#334155",
  background: "transparent"
}

function isDark() {
  return document.documentElement.classList.contains("dark")
}

function applyTheme() {
  const palette = isDark() ? DARK : LIGHT

  Chart.defaults.color = palette.text
  Chart.defaults.borderColor = palette.grid
  Chart.defaults.plugins.legend.labels.color = palette.text

  // Re-render all existing charts
  Object.values(Chart.instances).forEach((chart) => {
    const scales = chart.options.scales || {}
    Object.values(scales).forEach((scale) => {
      scale.ticks = scale.ticks || {}
      scale.ticks.color = palette.text
      scale.grid = scale.grid || {}
      scale.grid.color = palette.grid
    })
    chart.options.plugins = chart.options.plugins || {}
    chart.options.plugins.legend = chart.options.plugins.legend || {}
    chart.options.plugins.legend.labels = chart.options.plugins.legend.labels || {}
    chart.options.plugins.legend.labels.color = palette.text
    chart.update("none")
  })
}

// Apply on page load
document.addEventListener("turbo:load", () => {
  // Small delay to let chartkick render
  setTimeout(applyTheme, 100)
})

// Watch for dark mode toggle via MutationObserver on <html> class changes
const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.attributeName === "class") {
      applyTheme()
      break
    }
  }
})

observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] })
